<div class="list-container">
  @for (screeningResult of screening().results; track $index) {
    @let isValid = screeningResult.status === 'fulfilled';
    @let isInvalid = screeningResult.status === 'unfulfilled';
    @let isExpanded = expandedMap()[screeningResult.id];

    <div class="row">
      <div class="row-header">
        <rt-icon
          [name]="statusIconMap[screeningResult.status]"
          [colorToken]="isValid ? 'colorIconAiStrongDefault' : 'colorIconLowDefault'"
        />
        @if (!expandable()) {
          <span [class.invalid]="isInvalid">
            {{ screeningResult.criterionName }}
          </span>
        } @else {
          <div (click)="toggleExpand(screeningResult.id)" class="row-clickable">
            <span [class.invalid]="isInvalid"> {{ screeningResult.criterionName }} </span>
            <rt-icon [name]="isExpanded ? 'expand-less' : 'expand-more'" size="small" />
          </div>
        }
      </div>
      @if (expandable()) {
        @if (isExpanded) {
          <div class="expanded">
            {{ screeningResult.reason }}
            @if (!previewMode()) {
              <div class="actions">
                <div
                  [rtTooltip]="
                    !editable()
                      ? ('app.ai_candidate_screening.results.no_permission' | translate)
                      : ''
                  "
                >
                  <rt-button
                    size="small"
                    variant="plain"
                    class="edit-manually"
                    [disabled]="!editable()"
                    (click)="edit.emit(screeningResult)"
                  >
                    {{ 'app.ai_candidate_screening.results.edit_manually' | translate }}
                  </rt-button>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  }
  @if (!previewMode() && screening()?.matching?.status !== 'chosen' && hasScreenActions()) {
    <div layout margin-top-small-xx>
      <div [rtTooltip]="disabledTooltip()">
        <rt-button
          (click)="screenAgain.emit()"
          size="small"
          [disabled]="!editable() || usageLimitReached()"
        >
          <rt-icon prefix name="account-search" />
          {{ 'app.ai_candidate_screening.results.screen_again' | translate }}
        </rt-button>
      </div>
    </div>
  }
</div>
